var contact;

$(function(){
  contact = {
    alertMessage: function(msg,status){
      $(".formulario span.warning").removeClass("error").removeClass("success").addClass(status).html(msg);
 
    },
    send: function(){
      var nome = $("#nome").val(),
          empresa = $("#empresa").val(),
          email = $("#email").val(),
          mensagem = $("#mensagem").val();

      if(!nome){ contact.alertMessage("O campo Nome deve ser preenchido!","error"); $("#nome").focus(); return; }
      if(!empresa){ contact.alertMessage("O campo Nome da Empresa deve ser preenchido!","error"); $("#empresa").focus(); return; }
      if(!email){ contact.alertMessage("O campo E-mail deve ser preenchido!","error"); $("#email").focus(); return; }
      if(!mensagem){ contact.alertMessage("O campo Mensagem deve ser preenchido!","error"); $("#mensagem").focus(); return; }

      $(".formulario span.warning").html("");
      $(".formulario .loading").show();

      var mensagem_final = `<b>Nome:</b> ${nome}<br>
                            <b>Empresa:</b> ${empresa}<br>
                            <b>E-mail:</b> ${email}<br><br>
                            <b>Mensagem:</b><br><br>${mensagem}`;
       $.ajax({
        type: "POST",
        dataType: "json",
        url: "/api/v1/mail/send/",
        data: { "name": nome, "email": email, "message": mensagem_final },
        success: function (req) {
          $(".formulario .loading").hide();
          contact.alertMessage("Mensagem enviada com sucesso! Obrigado por entrar em contato.","success");
          $("#mensagem").val("")
        }
      });
    }
  }
  $("#btnSend").click(contact.send)
})
